import "./BannerHero.css";

const BannerHero = ({ image__banner__hero }) => {
  return <div className={`${image__banner__hero}`}></div>;
};

export default BannerHero;
